import { HttpClient } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import {
  AnalyticsGranularity,
  AnalyticsGroupBy,
  AnalyticsIncome,
  AnalyticsIncomesGroupBy,
  AnalyticsResponse
} from "src/app/backend/models/analytics";
import { omitUndefinedAndNullProperties } from "src/app/support/object";
import { environment } from "src/environments/environment";

@Injectable()
export class AnalyticsIncomesBackend {
  private readonly http = inject(HttpClient);

  list({
    from,
    to,
    granularity,
    groupBy,
    fiscalProfileId,
    limit,
    days,
    timeSlot
  }: {
    from: string;
    to: string;
    granularity: AnalyticsGranularity | "none";
    groupBy: AnalyticsGroupBy;
    fiscalProfileId: string | undefined;
    limit: number | undefined;
    days: number[] | undefined;
    timeSlot: [number, number] | undefined;
  }): Observable<AnalyticsResponse<AnalyticsIncome>> {
    return this.http
      .get<AnalyticsResponse<AnalyticsIncome>>(
        `${environment.snoots.api.analytics}/incomes`,
        {
          params: omitUndefinedAndNullProperties({
            from,
            to,
            granularity: granularity || "yearly",
            groupBy,
            fiscalProfileId,
            limit,
            daysOfWeek: days && days.length > 0 ? days.join(",") : undefined,
            timeslotFrom: timeSlot?.[0],
            timeslotTo: timeSlot?.[1]
          })
        }
      )
      .pipe(
        map((response) => ({
          ...response,
          totalAverage: response.totalAverage || 0
        }))
      );
  }

  export(params: {
    from: string;
    to: string;
    granularity: AnalyticsGranularity | "none";
    groupBy: AnalyticsIncomesGroupBy;
    fiscalProfileId: string | undefined;
    days: number[] | undefined;
    timeslot: [number, number] | null;
  }): Observable<void> {
    return this.http.post<void>(
      `${environment.snoots.api.analytics}/incomes/exports`,
      omitUndefinedAndNullProperties({
        from: params.from,
        to: params.to,
        granularity: params.granularity,
        groupBy: params.groupBy,
        daysOfWeek:
          params.days && params.days.length > 0
            ? params.days.join(",")
            : undefined,
        timeslotFrom: params.timeslot?.[0],
        timeslotTo: params.timeslot?.[1]
      })
    );
  }
}
